import React from "react";
import { Link } from "react-router-dom";
import { FiPhone, FiMapPin, FiMail, FiFacebook, FiInstagram, FiYoutube } from "react-icons/fi";
import { SAURABH, GAURI, SITE } from "../utils/siteData";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-maroon-900 text-gold-100/85">
      {/* refined gold top divider — thin solid line, not a flat gradient stripe */}
      <div className="h-px w-full bg-gradient-to-r from-transparent via-gold-500/70 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 pt-14 pb-10 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 rounded-full bg-gold-500 flex items-center justify-center text-maroon-900 text-xl font-heading shadow-gold">
              ॐ
            </div>
            <div>
              <p className="font-heading text-lg text-gold-200 leading-tight">{SITE.name}</p>
              <p className="text-[11px] text-gold-400/70 tracking-wide">Saurabh Shastri &amp; Gauri Shastri</p>
            </div>
          </div>
          <p className="text-sm text-gold-100/70 leading-relaxed">
            Authentic Vedic poojas by Pandit Saurabh Shastri and accurate astrology &amp; palmistry guidance by
            Gauri Shastri - proudly serving Thane, Mumbai and devotees worldwide.
          </p>
          <div className="flex gap-2.5 mt-5">
            <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white/5 border border-gold-500/20 flex items-center justify-center hover:bg-gold-500 hover:text-maroon-900 hover:border-gold-500 transition-colors">
              <FiFacebook />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white/5 border border-gold-500/20 flex items-center justify-center hover:bg-gold-500 hover:text-maroon-900 hover:border-gold-500 transition-colors">
              <FiInstagram />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube" className="w-9 h-9 rounded-full bg-white/5 border border-gold-500/20 flex items-center justify-center hover:bg-gold-500 hover:text-maroon-900 hover:border-gold-500 transition-colors">
              <FiYoutube />
            </a>
          </div>
        </div>

        {/* Quick links */}
        <div>
          <h4 className="font-heading text-gold-300 text-sm uppercase tracking-widest mb-5">Quick Links</h4>
          <ul className="space-y-3 text-sm">
            {[
              { to: "/", label: "Home" },
              { to: "/about", label: "About Us" },
              { to: "/pooja-services", label: "Pooja Services" },
              { to: "/astrology-palmistry-services", label: "Astrology & Palmistry" },
              { to: "/marketplace", label: "Marketplace" },
              { to: "/gallery", label: "Gallery" },
              { to: "/testimonials", label: "Reviews" },
              { to: "/blog", label: "Blog" },
              { to: "/contact", label: "Contact" },
            ].map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-gold-100/70 hover:text-gold-300 transition-colors inline-flex items-center gap-2 group">
                  <span className="text-gold-500 -ml-5 opacity-0 group-hover:opacity-100 group-hover:ml-0 transition-all">❯</span>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-heading text-gold-300 text-sm uppercase tracking-widest mb-5">Get in Touch</h4>
          <div className="space-y-5 text-sm">
            <div>
              <p className="text-gold-200 font-medium mb-1.5">Pandit Saurabh Shastri</p>
              <a href={`tel:+91${SAURABH.phone}`} className="flex items-center gap-2 text-gold-100/70 hover:text-gold-300 transition-colors">
                <FiPhone className="text-saffron-400" size={14} /> {SAURABH.phoneDisplay}
              </a>
            </div>
            <div>
              <p className="text-gold-200 font-medium mb-1.5">Gauri Shastri</p>
              <a href={`tel:+91${GAURI.phone}`} className="flex items-center gap-2 text-gold-100/70 hover:text-gold-300 transition-colors">
                <FiPhone className="text-saffron-400" size={14} /> {GAURI.phoneDisplay}
              </a>
            </div>
            <p className="flex items-start gap-2 text-gold-100/70">
              <FiMapPin className="text-saffron-400 mt-0.5 flex-shrink-0" size={14} />
              <span>Thane, Maharashtra &amp; Online Worldwide</span>
            </p>
          </div>
        </div>

        {/* Service areas + email */}
        <div>
          <h4 className="font-heading text-gold-300 text-sm uppercase tracking-widest mb-5">Service Areas</h4>
          <p className="text-sm text-gold-100/70 leading-relaxed">
            Thane West &amp; East, Ghodbunder Road, Majiwada, Mumbai, Navi Mumbai, Mulund, Dombivli, Kalyan
            &amp; nearby areas. Astrology consultations available online worldwide.
          </p>
          <a href="mailto:info@tathastujotishalaya.com" className="mt-5 flex items-center gap-2 text-sm text-gold-100/70 hover:text-gold-300 transition-colors break-all">
            <FiMail className="text-saffron-400 flex-shrink-0" size={14} />
            info@tathastujotishalaya.com
          </a>
        </div>
      </div>

      <div className="border-t border-gold-700/20">
        <div className="max-w-7xl mx-auto px-4 py-4 text-center text-xs text-gold-100/55">
          © {year} {SITE.name}. All rights reserved. | Saurabh Shastri &amp; Gauri Shastri, Thane
        </div>
      </div>
    </footer>
  );
}
